import styled from 'styled-components'
import Title from './StyledTitle'

export default styled(Title)`
  font-size: 14px;
  line-height: 30px;
  margin: 0;
`
